module.exports = __webpack_public_path__ + "images/left-697c3794bc12d647ae6302af43a63f24.png";